// Core React Imports
import React from "react";

// Local Imports
import { AlertDialogBackground, DivColumn, DivRow, Input, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import WidgetCheckbox from "../../checkboxes/WidgetCheckbox";
import WidgetDropdown from "../../dropdowns/widget-dropdown/WidgetDropdown";
import WidgetFixedSizeList from "../../shared_widgets/widget-fixed-size-list/WidgetFixedSizeList";
import useWidgetAlertDialogUsers from "./useWidgetAlertDialogUsers";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";
import WidgetIconFour from "../../icons/widget-icon-four/WidgetIconFour";

// CSS/Stylesheets
import "./WidgetAlertDialogUsers.css";

const WidgetAlertDialogUsers = () => {
  const {
    roleOptions,
    ROLE_CONFIG,
    handleRoleSelect,
    handleClose,
    users,
    currentUser,
    getRoleNameByNumber,
    searchText,
    handleSearchChange,
    selectedRoleFilters,
    handleRoleFilterChange,
    usersWithRoleGreaterThanZero,
  } = useWidgetAlertDialogUsers();

  const renderHeader = () => (
    <DivRow className="alert-dialog-overlay-users-2">
      <WidgetIconFour iconProp={ConstantsImages.CLOSE_3_IMAGE} widthIconProp="1.1rem" heightIconProp="1.1rem" handleOnClickProp={handleClose} />
      <DivColumn className="alert-dialog-overlay-users-3">
        <ParagraphText className="alert-dialog-overlay-users-text">{usersWithRoleGreaterThanZero}</ParagraphText>
        <ParagraphText className="alert-dialog-overlay-users-text-2">{ConstantsTexts.CODE_213}</ParagraphText>
      </DivColumn>
    </DivRow>
  );

  const renderSearchSection = () => (
    <DivColumn className="alert-dialog-overlay-users-4">
      <DivRow className="alert-dialog-overlay-users-5">
        <DivColumn className="alert-dialog-overlay-users-6">
          <Input
            placeholder={ConstantsTexts.CODE_224}
            style={{ color: "#2E2E2E", fontFamily: "Almoni DL AAA", fontSize: "1.2rem", fontWeight: "700" }}
            value={searchText}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </DivColumn>
        <WidgetIconFive iconProp={ConstantsImages.SEARCH_BLACK_IMAGE} widthIconProp="1.7rem" heightIconProp="1.7rem" />
      </DivRow>
    </DivColumn>
  );

  const renderUserRoleItem = (roleName) => (
    <DivRow className="alert-dialog-overlay-users-8">
      <WidgetCheckbox checked={selectedRoleFilters[roleName]} onChange={(newValue) => handleRoleFilterChange(roleName, newValue)} />
      <ParagraphText className="alert-dialog-overlay-users-text-5">{roleName}</ParagraphText>
    </DivRow>
  );

  const renderUserRoles = () => (
    <DivRow className="alert-dialog-overlay-users-7">
      <ParagraphText className="alert-dialog-overlay-users-text-4">{ConstantsTexts.CODE_215}</ParagraphText>
      {ROLE_CONFIG.map((role) => renderUserRoleItem(role.textKey))}
    </DivRow>
  );

  const renderUserItemName = (user, color) => {
    const fullName = user.fullName || user.email.split("@")[0];
    const firstLetter = fullName.charAt(0).toUpperCase();

    return (
      <DivRow className="alert-dialog-overlay-users-10">
        <DivColumn className="alert-dialog-overlay-users-11" style={{ backgroundColor: color }}>
          <ParagraphText className="alert-dialog-overlay-users-text-6">{firstLetter}</ParagraphText>
        </DivColumn>
        <DivColumn className="alert-dialog-overlay-users-12">
          <ParagraphText className="alert-dialog-overlay-users-text-7" style={{ color: color }}>
            {fullName}
          </ParagraphText>
          <ParagraphText className="alert-dialog-overlay-users-text-8" style={{ color: color }}>
            {user.email}
          </ParagraphText>
        </DivColumn>
      </DivRow>
    );
  };

  const renderCurrentUser = () => {
    if (!currentUser) return null;

    return (
      <DivRow className="alert-dialog-overlay-users-9">
        {renderUserItemName(currentUser, "#AEC1FF")}
        <ParagraphText className="alert-dialog-overlay-users-text-9">{getRoleNameByNumber(currentUser.UserTypeTerminal)}</ParagraphText>
      </DivRow>
    );
  };

  const renderUserItem = ({ index, style }) => {
    const user = users[index];

    if (!user) return null;

    return (
      <div style={style}>
        <DivRow className="alert-dialog-overlay-users-13">
          <DivRow className="alert-dialog-overlay-users-14">{renderUserItemName(user, "#FFF")}</DivRow>
          <DivRow className="alert-dialog-overlay-users-15">
            <WidgetDropdown
              options={roleOptions}
              onSelect={(role) => handleRoleSelect(role, user.sub)}
              labelKey="role_name"
              selectedOptionProp={user.roleOption}
              arrowImage={ConstantsImages.ARROW_WHITE_IMAGE}
              widthProp="10.5rem"
              heightProp="4rem"
              backgroundColorProp="transparent"
              fontWeightTitle="700"
              fontSizeText="1.2rem"
              fontWeightText="700"
              textColorProp="#FFF"
              textAlignText="right"
              usePortal={true}
            />
          </DivRow>
        </DivRow>
      </div>
    );
  };

  const renderUsers = () => {
    if (users.length === 0) {
      return (
        <DivColumn className="alert-dialog-overlay-users-16">
          <ParagraphText style={{ color: "#FFF", textAlign: "center" }}>
            {searchText.trim() || Object.values(selectedRoleFilters).some((v) => !v) ? ConstantsTexts.CODE_221 : ConstantsTexts.CODE_222}
          </ParagraphText>
        </DivColumn>
      );
    }

    return (
      <DivColumn className="alert-dialog-overlay-users-16">
        <WidgetFixedSizeList height={19} itemCount={users.length} itemSize={4}>
          {renderUserItem}
        </WidgetFixedSizeList>
      </DivColumn>
    );
  };

  return (
    <AlertDialogBackground>
      <DivColumn className="alert-dialog-overlay-users">
        {renderHeader()}
        {renderSearchSection()}
        {renderUserRoles()}
        {renderCurrentUser()}
        {renderUsers()}
      </DivColumn>
    </AlertDialogBackground>
  );
};

export default WidgetAlertDialogUsers;
